import React from 'react';
import { Transition, TransitionGroup } from 'react-transition-group';

/**
 * material ui
 */
import { useScrollTrigger, Zoom, makeStyles, Fab } from '@material-ui/core';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

/**
 * components
 */
import Header from '../digital-media/Header';
import SubHeader from '../digital-media/SubHeader';
import Footer from '../footer';
import GlobalStyles from '../GlobalStyles';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    paddingTop: '85px',
  },
  root: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
}));

/**
 * top bar
 */
function ScrollTop(props) {
  const { children, window } = props;
  const classes = useStyles();

  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector(
      '#back-to-top-anchor',
    );

    if (anchor) {
      anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  return (
    <Zoom in={trigger}>
      <div onClick={handleClick} role="presentation" className={classes.root}>
        {children}
      </div>
    </Zoom>
  );
}

export default ({ children, location }) => (
  <>
    <GlobalStyles />
    <div id="back-to-top-anchor"></div>
    <Header />
    <SubHeader />
    {children}
    <Footer />
    <ScrollTop {...children}>
      <Fab color="default" size="medium" aria-label="scroll back to top">
        <KeyboardArrowUpIcon />
      </Fab>
    </ScrollTop>
  </>
);
